<template>
  <footer class="site-footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-logo">
          <img src="../assets/logo.png" alt="Photo Enhancer Logo" class="footer-logo-img" />
          <h2>Photo Enhancer - AI Upscale</h2>
          <p>Transform your photos with AI technology</p>
        </div>
        
        <div class="footer-links">
          <div class="footer-links-column">
            <h3>Quick Links</h3>
            <ul>
              <li><router-link to="/">Home</router-link></li>
              <li><router-link to="/services">Services</router-link></li>
              <li><router-link to="/about">About</router-link></li>
            </ul>
          </div>
          
          <div class="footer-links-column">
            <h3>Services</h3>
            <ul>
              <li><a href="javascript:void(0)">Photo Enhancement</a></li>
              <li><a href="javascript:void(0)">AI Upscaling</a></li>
              <li><a href="javascript:void(0)">Image Enlarger</a></li>
              <li><a href="javascript:void(0)">Image Enhancer</a></li>
            </ul>
          </div>
          
          <div class="footer-links-column">
            <h3>Connect With Us</h3>
            <div class="social-links">
              <a href="#" class="social-link"><i class="fab fa-facebook-f"></i></a>
              <a href="#" class="social-link"><i class="fab fa-twitter"></i></a>
              <a href="#" class="social-link"><i class="fab fa-instagram"></i></a>
              <a href="#" class="social-link"><i class="fab fa-linkedin-in"></i></a>
            </div>
            <p class="contact-info">Email: yikenxinxin@gmail.com</p>
            <a href="mailto:yikenxinxin@gmail.com" class="contact-btn">Contact Us</a>
          </div>
        </div>
      </div>
      
      <div class="footer-bottom">
        <p>Copyright © 2022.markwatermark.com All rights reserved</p>
        <div class="footer-bottom-links">
          <router-link to="/privacy">Privacy Policy</router-link>
          <router-link to="/terms">Terms of Service</router-link>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterComponent',
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  }
}
</script>

<style lang="scss" scoped>
.site-footer {
  background-color: #1a1a2e;
  color: #f0f0f0;
  padding: 60px 0 30px;
  
  .footer-content {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 40px;
  }
  
  .footer-logo {
    flex: 0 0 300px;
    margin-bottom: 30px;
    
    .footer-logo-img {
      height: 50px;
      margin-bottom: 15px;
    }
    
    h2 {
      font-size: 24px;
      margin-bottom: 10px;
      color: white;
    }
    
    p {
      font-size: 14px;
      color: #b8b8b8;
      line-height: 1.6;
    }
  }
  
  .footer-links {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    gap: 30px;
    
    .footer-links-column {
      min-width: 160px;
      
      h3 {
        font-size: 18px;
        margin-bottom: 20px;
        color: white;
        position: relative;
        
        &::after {
          content: '';
          position: absolute;
          bottom: -8px;
          left: 0;
          width: 40px;
          height: 2px;
          background: var(--primary-gradient);
        }
      }
      
      ul {
        list-style: none;
        padding: 0;
        margin: 0;
        
        li {
          margin-bottom: 12px;
          
          a {
            color: #b8b8b8;
            text-decoration: none;
            transition: color 0.3s ease;
            font-size: 14px;
            display: block;
            
            &:hover {
              color: var(--primary-color);
            }
          }
        }
      }
      
      .social-links {
        display: flex;
        gap: 15px;
        margin-bottom: 20px;
        
        .social-link {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 36px;
          height: 36px;
          background-color: rgba(255, 255, 255, 0.1);
          border-radius: 50%;
          color: white;
          transition: all 0.3s ease;
          
          &:hover {
            background-color: var(--primary-color);
            transform: translateY(-3px);
          }
          
          i {
            font-size: 16px;
          }
        }
      }
      
      .contact-info {
        font-size: 14px;
        color: #b8b8b8;
        margin-bottom: 20px;
      }
      
      .contact-btn {
        display: inline-block;
        background: var(--primary-gradient);
        color: white;
        padding: 10px 20px;
        border-radius: 4px;
        text-decoration: none;
        font-size: 14px;
        font-weight: 600;
        transition: all 0.3s ease;
        
        &:hover {
          transform: translateY(-3px);
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
        }
      }
    }
  }
  
  .footer-bottom {
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    padding-top: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 20px;
    
    p {
      font-size: 14px;
      color: #b8b8b8;
    }
    
    .footer-bottom-links {
      display: flex;
      gap: 20px;
      
      a {
        font-size: 14px;
        color: #b8b8b8;
        text-decoration: none;
        transition: color 0.3s ease;
        
        &:hover {
          color: var(--primary-color);
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .site-footer {
    .footer-content {
      flex-direction: column;
    }
    
    .footer-logo {
      text-align: center;
      margin: 0 auto 30px;
    }
    
    .footer-links {
      justify-content: space-between;
      
      .footer-links-column {
        flex: 0 0 45%;
        margin-bottom: 30px;
        
        h3 {
          &::after {
            left: 50%;
            transform: translateX(-50%);
          }
        }
        
        ul {
          text-align: center;
        }
        
        .social-links {
          justify-content: center;
        }
        
        .contact-info {
          text-align: center;
        }
        
        .contact-btn {
          display: block;
          text-align: center;
          margin: 0 auto;
        }
      }
    }
    
    .footer-bottom {
      flex-direction: column;
      text-align: center;
      
      .footer-bottom-links {
        justify-content: center;
      }
    }
  }
}
</style> 